import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { type CarouselCardProps } from '@post-office/browser--growth-starburst/common/carouselBaseCard/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import { PlacementFrontend } from '@post-office/browser--townsquare/townsquare-onboarding-widget';

import { StudioOnboardingCard } from '../../../components/StudioOnboardingCard';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<CarouselCardProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<CarouselCardProps>(),
		Component: (props: CarouselCardProps) => <StudioOnboardingCard {...props} />,
	},
});
